// TicketActions — the capture ticket's ONE registry (ADR-036 §7 — the four kinds;
// mirrors the exemplar `pages/teams/TeamActions.tsx`). The panel's filing verbs,
// in its door — the lifecycle (ADR-073 §2): Close ticket (from COMPLETED only —
// the row stays, disabled, while the visit is open or photos wait, and says when:
// "After the ticket is completed"; the card above shows the doors) · Reopen (a closed ticket) · "Nothing to
// classify, close" (photos wait for review, for a holder of BOTH keys — the
// filing key and the review key). The panel resolves `ticketActs` with its own
// handlers (the mutations and the confirm live with it); the shape test walks it.

import type { CaptureStage } from '@ems-app/schemas/tickets/vocabulary';
import type { ActionItem } from '../../components/patterns/entityRegistry.js';

/** What each act does — the panel wires these. */
export interface TicketActHandlers {
  close: () => void;
  reopen: () => void;
  nothingClose: () => void;
}

/** The closed-over facts the rows read beside the stage. */
export interface TicketActFacts {
  /** The viewer holds the review key too (`files:review`). */
  canReview: boolean;
  /** The ticket stands at COMPLETED — the one stage Close acts from. */
  completed: boolean;
}

/** The ticket's registry — pure: the rows, their kinds and predicates (the status is the stage). */
export function ticketActs(h: TicketActHandlers, facts: TicketActFacts): ActionItem<CaptureStage>[] {
  return [
    { id: 'close', kind: 'lifecycle', labelKey: 'actions.close', run: { handler: h.close }, gate: 'ticket.capture:manage', order: 10, show: (ctx) => ctx.status !== 'closed', disabled: !facts.completed, disabledNoteKey: 'actions.closeWhen' },
    { id: 'nothing-close', kind: 'lifecycle', labelKey: 'actions.nothingClose', run: { handler: h.nothingClose }, gate: 'ticket.capture:manage', order: 20, show: (ctx) => ctx.status === 'to_review' && facts.canReview },
    { id: 'reopen', kind: 'lifecycle', labelKey: 'actions.reopen', run: { handler: h.reopen }, gate: 'ticket.capture:manage', order: 10, show: (ctx) => ctx.status === 'closed' },
  ];
}
